import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

const useCreatetSolicitudGastosContingenciaProfesionalIt = () => {
  const [loadingSolicitudGastosContingenciaProfesionalIt, setLoadingCreateSolicitudGastosContingenciaProfesional] = useState(false);
  const [successSolicitudGastosContingenciaProfesionalIt, setSuccessCreateSolicitudGastosContingenciaProfesional] = useState(false);
  const [errorSolicitudGastosContingenciaProfesionalIt, setErrorCreateSolicitudGastosContingenciaProfesional] = useState(null);
  const [dataSolicitudGastosContingenciaProfesionalIt, setDataSolicitudGastosContingenciaProfesional] = useState(null);

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apiRecord = new record.RecordService(
    BASE_URL,
    FUNCTIONS_KEY
  )



  //CREATE
  const createSolicitudGastosContingenciaProfesionalIt = async (userId:string ,prestacionId: string, data: any ,_cb?:(data:any)=>void) => {
    setLoadingCreateSolicitudGastosContingenciaProfesional(true);
    setSuccessCreateSolicitudGastosContingenciaProfesional(false);
    setErrorCreateSolicitudGastosContingenciaProfesional(null);

    apiRecord.newSolicitudGastosContingenciaProfesionalIt(userId, data).then((res: any) => {
      setLoadingCreateSolicitudGastosContingenciaProfesional(false);
      setSuccessCreateSolicitudGastosContingenciaProfesional(true);
      setDataSolicitudGastosContingenciaProfesional(res.data);
      if (typeof _cb === "function") {
        _cb(res.data);
      }

    }).catch((err:any) => {
      console.log(err)
      setLoadingCreateSolicitudGastosContingenciaProfesional(false);
      setErrorCreateSolicitudGastosContingenciaProfesional(err.response.data)
    })
  }




  return {
    createSolicitudGastosContingenciaProfesionalIt,
    loadingSolicitudGastosContingenciaProfesionalIt,
    successSolicitudGastosContingenciaProfesionalIt,
    errorSolicitudGastosContingenciaProfesionalIt,
    dataSolicitudGastosContingenciaProfesionalIt
  }

}

export default useCreatetSolicitudGastosContingenciaProfesionalIt;
